const operations = [
  {
    title: 'Operations',
    icon: 'SettingsIcon',
    enableFeature: true,
    children: [
      {
        title: 'Approvals',
        enableFeature: true,
        children: [
          {
            title: 'All Approvals',
            route: 'all-approvals',
            hasPermission: 'VIEW_ALL_APPROVALS',
            enableFeature: true,
          },
          {
            title: 'My Approvals',
            route: 'approvals-request',
            hasPermission: 'VIEW_MY_APPROVALS',
            enableFeature: true,
          },
          {
            title: 'Pending Approvals',
            route: 'pending-approvals',
            hasPermission: 'VIEW_PENDING_APPROVALS',
            enableFeature: true,
          },
          {
            title: 'Posting Approvals Setup',
            route: 'posting-approvals',
            hasPermission: 'VIEW_POSTING_APPROVAL',
            enableFeature: true,
          },
          {
            title: 'Non Posting Approval Setup',
            route: 'setup',
            hasPermission: 'VIEW_APPROVAL_SETUP',
            enableFeature: true,
          },
        ],
      },
      {
        title: 'Multi Currency',
        enableFeature: true,
        children: [
          {
            title: 'Currency',
            route: 'currency',
            hasPermission: 'VIEW_CURRENCY',
            enableFeature: true,
          },
          {
            title: 'Currency Rates',
            route: 'currency-rates',
            hasPermission: 'VIEW_CURRENCY_RATE',
            enableFeature: true,
          },
        ],
      },
      {
        title: 'Audit Trail',
        route: 'audit-trail',
        hasPermission: 'AUDIT_TRAIL',
        enableFeature: true,
      },
      {
        title: 'Business Automation',
        hasPermission: 'VIEW_BUSINESS_AUTOMATION',
        enableFeature: true,
        children: [
          {
            title: 'Other Businesses',
            route: 'other-businesses',
            enableFeature: true,
          },
          {
            title: 'Till Account',
            route: 'till-account',
            enableFeature: true,
          },
          {
            title: 'Vault Account',
            route: 'vault-account',
            enableFeature: true,
          },
          {
            title: 'Mobile Till Account',
            route: 'mobile-till-account',
            enableFeature: true,
          },
          {
            title: 'Shortages Account',
            route: 'shortages-account',
            enableFeature: true,
          },
          {
            title: 'Overage Account',
            route: 'overage-account',
            enableFeature: true,
          },
          {
            title: 'Cash Suspense Account',
            route: 'cash-suspense-account',
            enableFeature: true,
          },
          // {
          //   title: 'Inter-Branch Transaction Account',
          //   route: 'inter-branch-transaction',
          // },
          {
            title: 'Cheque Clearing Account',
            route: 'cheque-clearing-account',
            enableFeature: true,
          },
          {
            title: 'Cheque Receivable Account',
            route: 'cheque-receivable-account',
            enableFeature: true,
          },
          {
            title: 'Uncleared Cheque Account',
            route: 'uncleared-cheque-account',
            enableFeature: true,
          },
        ],
      },
      {
        title: 'Business',
        route: 'business',
        hasPermission: 'OPEN_CLOSE_BUSINESS_HISTORY',
        enableFeature: true,
      },
      {
        title: 'Branch',
        route: 'branch',
        hasPermission: 'VIEW_BRANCH',
        enableFeature: true,
      },
      // {
      //   title: 'Configurations',
      //   route: 'configuration',
      //   hasPermission: 'VIEW_SYSTEM_SETUP',
      //   enableFeature: true,
      // },
      {
        title: 'Notifications',
        enableFeature: true,
        children: [
          {
            title: 'SMS & Email',
            route: 'sms-email-notification',
            hasPermission: 'VIEW_COMMS_TEMPLATE',
            enableFeature: true,
          },
          {
            title: 'Webhook',
            route: 'webhook-notifications',
            hasPermission: 'WEBHOOK_NOTIFICATION_REPORT',
            enableFeature: true,
          },
          {
            title: 'Email Report',
            route: 'view-email-report',
            hasPermission: 'VIEW_EMAIL_REPORT',
            enableFeature: true,
          },
          {
            title: 'SMS Report',
            route: 'view-sms-report',
            hasPermission: 'VIEW_SMS_REPORT',
            enableFeature: true,
          },
        ],
      },
      {
        title: 'Utility',
        enableFeature: true,
        children: [
          {
            title: 'Bulk SMS',
            route: 'bulk-sms',
            hasPermission: 'BULK_SMS',
            enableFeature: true,
          },
          {
            title: 'View SMS Wallet',
            route: 'view-sms-wallet',
            hasPermission: 'VIEW_SMS_WALLET',
            enableFeature: true,
          },
          {
            title: 'View KYC Wallet',
            route: 'view-kyc-wallet',
            hasPermission: 'VIEW_KYC_WALLET',
            enableFeature: true,
          },
          {
            title: 'Recompute EOD Balance',
            route: 'recompute-eod-balance',
            hasPermission: 'RECOMPUTE_EOD_BALANCE',
            enableFeature: true,
          },
          {
            title: 'Recompute Loan Status',
            route: 'recompute-loan-status',
            hasPermission: 'RECOMPUTE_EOD_BALANCE',
            enableFeature: true,
          },
        ],
      },
      {
        title: 'Configurations',
        enableFeature: true,
        children: [
          {
            title: 'Configurations',
            route: 'configuration',
            hasPermission: 'VIEW_SYSTEM_SETUP',
            enableFeature: true,
          },
          {
            title: 'Institution Limit',
            route: 'institution-limit',
            hasPermission: 'VIEW_INSTITUTION_LIMIT',
            enableFeature: true,
          },
        ],
      },
      {
        title: 'Region',
        route: 'region',
        hasPermission: 'VIEW_REGION',
        enableFeature: true,
      },
    ],
  },
]
export default operations
